import $ from "jquery";

$(document).ready(function () {
  // Anno
  $("select.years").on("change", function () {
    const value = $("option:selected", this).val();
    composeUrl("prj_year", value);
  });

  // Settore
  $("select.sectors").on("change", function () {
    const value = $("option:selected", this).val();
    composeUrl("sector", value);
  });

  // Collections
  $("select.collections").on("change", function () {
    const value = $("option:selected", this).val();
    composeUrl("col", value);
  });

  // Designers
  $("select.designers").on("change", function () {
    const value = $("option:selected", this).val();
    composeUrl("des", value);
  });

  // Pagination
  $("span.page-number").on("click", function () {
    const value = $(this).attr("data-value");
    composeUrl("pg", value);
  });
});

function composeUrl(key, value) {
  const url = new URL(document.location.href);

  // Remove element if is already present and values is empty
  if (url.searchParams.has(key) && value === "") {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }

  // Check for configurable param
  if (key === "configurable" && value === false) {
    url.searchParams.delete(key);
  }

  // Check pagination offsets
  if (url.searchParams.has("pg")) {
    const max = $('input[name="max-pages"]').val() ?? 1;
    if (parseInt(url.searchParams.get("pg")) > parseInt(max)) {
      url.searchParams.delete("pg");
    }
  }

  // Remove pagination if another filter is entered
  if (key !== "pg" && url.searchParams.has("pg")) {
    url.searchParams.delete("pg");
  }

  // Redirect
  document.location = url.href;
}
